import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

function Button({ className, children, to, onClick }) {
  return (
    <Link className={className} to={to} onClick={onClick}>
      {children}
    </Link>
  )
}

Button.defaultProps = {
  to: '/'
}

/* eslint-disable react/require-default-props */
Button.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func
}

export default Button
